/** Created by azhou on 2019/4/2.*/
<template>
  <div class="border rounded bg-base mb-4 text-left p-4">
    <span class="font-weight-bold h4">{{userInfo.level==3?'积分规则及说明':'等级规则及说明'}}</span>
    <!-- <ul class="mt-3" v-if="userInfo.type===3">
      <li class="mb-2">
        <span class="mr-2 text-danger">(1)</span>独家图标：<img src="/images/grade/vip.png" alt="独家特权">
      </li>
      <li class="mb-2"><span class="mr-2 text-danger">(2)</span>立即获得活跃值10000点。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(3)</span>您的酒店的名称将以红色显示。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(4)</span>提现免手续费。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(5)</span>无需支付广告费，即可享受平台首页推广。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(6)</span>享受不定期微信软文推广。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(7)</span>优先参加平台组织的答谢活动。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(8)</span>建立供应商直通车（方便与酒店加强联系、优先处理投诉等。）</li>
      <li class="mb-2"><span class="mr-2 text-danger">(9)</span>邀请酒店总经理进入订单雨酒店研究院。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(10)</span>优先接收平台匹配订单。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(11)</span>享受平台酒店展示页时排名靠前。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(12)</span>优先参加景区+酒店产品计划。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(13)</span>在众多报价酒店中，平台将向采购商优先推荐独家酒店。</li>
      <li class="text-danger text-right h4">签约热线：0571-89986918</li>
    </ul>
    <ul class="mt-3" v-if="userInfo.type===5">
      <li class="mb-2"><span class="mr-2 text-danger">(1)</span>立即获得活跃值10000点。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(2)</span>提现免手续费。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(3)</span>无需支付广告费，即可享受平台首页推广。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(4)</span>享受不定期微信软文推广。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(5)</span>优先参加平台组织的答谢活动。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(6)</span>建立供应商直通车（方便与民宿加强联系、优先处理投诉等。）</li>
      <li class="mb-2"><span class="mr-2 text-danger">(7)</span>邀请民宿总经理进入订单雨民宿研究院。</li>
      <li class="mb-2"><span class="mr-2 text-danger">(8)</span>优先参加景区+民宿产品计划。</li>
      <li class="text-danger text-right h4">签约热线：0571-89986918</li>
    </ul> -->
    <!-- <ul class="mt-3" v-if="userInfo.type===3">
      <li class="mb-2"><span class="mr-2 text-danger">(1)</span>参与订单报价(+10)</li>
      <li class="mb-2"><span class="mr-2 text-danger">(2)</span>订单成交并完成(+订单金额10%)</li>
      <li class="mb-2"><span class="mr-4 text-danger"></span>
      如:订单金额为
      <span class="mr-1 text-warning">10800</span>元,则取<span class="mr-1 text-warning">10%</span>后得<span class="mr-1 text-warning">1080</span>点活跃值
      </li>
      <li class="mb-2"><span class="mr-4 text-danger"></span>
      如:订单金额为
      <span class="mr-1 text-warning">128</span>元,则取<span class="mr-1 text-warning">10%</span>后得<span class="mr-1 text-warning">12</span>点活跃值
      </li>
      <li class="mb-2">
        <span class="mr-2 text-danger">(1)</span>独家图标：<img src="/images/grade/vip.png" alt="独家特权">
      </li>
    </ul> -->
    <ul class="mt-3" v-if="userInfo.level===3">
      <li class="mb-2"><span class="mr-2 text-danger">(1)</span>发布订单(+10)</li>
      <li class="mb-2"><span class="mr-2 text-danger">(2)</span>订单成交并完成(+订单金额1:1积分数)</li>
      <li class="mb-2"><span class="mr-4 text-danger"></span>
      如:订单金额为
      <span class="mr-1 text-warning">10800</span>元,则取<span class="mr-1 text-warning">1:1</span>后得<span class="mr-1 text-warning">10800</span>点积分
      </li>
      <li class="mb-2"><span class="mr-4 text-danger"></span>
      如:订单金额为
      <span class="mr-1 text-warning">128</span>元,则取<span class="mr-1 text-warning">1:1</span>后得<span class="mr-1 text-warning">128</span>点积分
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name:'ExclusivePrivilege',
    computed:{
      ...mapGetters(['userInfo'])
    }
  }
</script>
